import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingScreen from './LoadingScreen';

interface AdminRouteProps {
  element: React.ReactNode;
}

/**
 * A protected route component that only allows access to admin users
 * Will redirect to the dashboard if the user is not an admin
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ element }) => {
  const auth = useAuth();
  
  // Show loading screen while authentication state is being determined
  if (auth.isLoading) {
    return <LoadingScreen message="Checking admin access..." />;
  }
  
  // Check if the user is authenticated and has admin role
  if (auth.isAuthenticated && auth.isAdmin()) {
    return <>{element}</>;
  }
  
  // Redirect to dashboard if not admin
  return <Navigate to="/dashboard" replace />;
};

export default AdminRoute;